import React from "react";
import AggregatedSummaryList from "components/AggregatedSummaryList/AggregatedSummaryList";
import { RESPONSE_PROGRAM_TYPE_LIST_COLUMNS } from "lookup/ProgramTypeSummaryListColumns";
import { DEFAULT_RAW_FAX_PROGRAM_CODE } from "lookup/RawConstants";
import { showNotification } from "services/NotificationService";

const rawProgramTypeListConfig = {
  id: "raw-program-type-list",
  mode: "api-driven",

  cache: { enabled: false },

  header: {
    totalLabel: "Total Raw Faxes",
    title: "Response List",
    totalCountColumn: "rawCount",
  },

  fetch: {
    url: "/raw/program-type-list",
    mapResponse: (response) => ({
      rows: response?.data?.rawProgramTypeList || [],
    }),
  },

  notifications: {
    loadError: {
      title: "Unable to load Raw program data!",
      message: "SOMETHING WENT WRONG",
    },
  },

  table: {
    getColumns: () => RESPONSE_PROGRAM_TYPE_LIST_COLUMNS(),
    showPagination: false,
    pageSize: 25,
    rowClassName: "clickable-row",
  },

  rowClick: {
    onRowClick: (row, navigate) => {
      if (!row.original.rawCount) {
        showNotification({
          title: "No Faxes Available",
          message: `Fax program type "${row.original.faxProgramTypeName || row.original.faxProgramTypeCode}" has 0 faxes.`,
          position: "tr",
          type: "warning",
        });
        return;
      }

      const faxProgramCode = row.original.faxProgramTypeCode;
      if (!faxProgramCode) {
        navigate(
          `/raw/list?${new URLSearchParams({ faxProgramCode: DEFAULT_RAW_FAX_PROGRAM_CODE }).toString()}`
        );
        return;
      }

      const query = new URLSearchParams({ faxProgramCode }).toString();
      navigate(`/raw/list?${query}`, { state: { reset: true } });
    },
  },
};

const RawProgramTypeList = () => (
  <AggregatedSummaryList config={rawProgramTypeListConfig} />
);

export default RawProgramTypeList;
